import api from "@/services/api/api-candidates"
import apiLabels from "@/services/api/api-labels"
import ReservationItem from "./candidates-reservation-model"
import { CANDIDATE_PAGE, SET_MIJN_ARGS, BULK_MIJN } from "./candidates-const"
import { convertToDefaultBackendFormat, dateFormating, convertToDefaultDatetimeBackendFormat } from "@/util"
import { EMAIL_TEMPLATE_ARGS } from "./models/CandidatesEmailTemplateModel"
import HandleFailedModel from "./models/candidatesHandleFailedModel"

export default class ReservationService {
  async list(query, page) {
    try {
      if(page === CANDIDATE_PAGE.MIJN_CBR_QUEUE) 
        query = this.removeNotUsedQuery(query)
      let request = this._listSwitcher(page)
      let res = await request(query)
      if(!res.results) throw new Error('Something wrong and candidates not loading. Please, reload page or try later.')
      let data = {
        results: res.results.map( item => new ReservationItem(item)),
        pagination: {
          count: res.count,
          next: res.next,
          previous: res.previous
        },
        candidates_counts: res.candidates_counts
      }
      return data
    } catch (error) {
      return Promise.reject(error)
    }
  }

  removeNotUsedQuery(query) {
    let _query = {...query}
    if('course_exam_id' in _query) delete _query.course_exam_id
    if('page_name' in _query) delete _query.page_name
    if('city' in _query) delete _query.city
    return _query
  }

  async fullListIds(query, page) {
    try {
      let request = this._listSwitcher(page)
      let res = await request(query)
      if(!res) throw new Error('Something went wrong and full candidates list is not loading. Please, reload page or try later.')
      const data = res.map(itemId => {
        return {
          ID: itemId
        }
      })
      return data;
    } catch (error) {
      return Promise.reject(error)
    }
  }
  _listSwitcher(page) {
    let apiRequest = api.listTask
    switch (page) {
    case CANDIDATE_PAGE.TASKS:
      apiRequest = api.listTask
      break;
    case CANDIDATE_PAGE.WAIT:
      apiRequest = api.listWait
      break;
    case CANDIDATE_PAGE.TOB_CBR_EXCHANGE_QUEUE:
      apiRequest = api.listExchange
      break;
    case CANDIDATE_PAGE.TOB_CBR_RESERVE_QUEUE:
      apiRequest = api.listReserve
      break;
    case CANDIDATE_PAGE.RESERVE_EXCHANGE:
      apiRequest = api.listReserveExchange
      break;
    case CANDIDATE_PAGE.RESERVED_EXCHANGED:
      apiRequest = api.listReservedExchanged
      break;
    case CANDIDATE_PAGE.PROCESSED:
      apiRequest = api.listProcessed
      break;
    case CANDIDATE_PAGE.RESERVED_ALL:
      apiRequest = api.listReservedAll
      break;
    case CANDIDATE_PAGE.RESERVED_ALL_WILL_COME:
      apiRequest = api.listReservedAllWillCome
      break;
    case CANDIDATE_PAGE.RESERVED_ALL_WILL_NOT_COME:
      apiRequest = api.listReservedAllWillNotCome
      break;
    case CANDIDATE_PAGE.MIJN_CBR_QUEUE:
      apiRequest = api.listMijnCbrQueue
      break;
    case CANDIDATE_PAGE.TOP_CBR_QUEUE:
      apiRequest = api.listTopCbrQueue
      break;
    case CANDIDATE_PAGE.ALL:
      apiRequest = api.list
      break;
    default:
      break;
    }
    return apiRequest
  }

  async create(model) {
    try {
      let res = await api.create(model.getApiData())
      return res
    } catch (error) {
      return Promise.reject(error)
    }
  }

  async find(ID) {
    try {
      let res = await api.find(ID)
      return res
    } catch (error) {
      console.log(error)
      return Promise.reject(error)
    }
  }

  async findSimilar(ID) {
    try {
      let res = await api.findSimilar(ID)
      return res.map(item => new ReservationItem(item))
    } catch (error) {
      console.log(error)
      return Promise.reject(error)
    }
  }

  async findByNumber(number) {
    try {
      let res = await api.findByNumber(number)
      return res
    } catch (error) {
      return Promise.reject(error)
    }
  }

  async put(ID, model) {
    try {
      let res = await api.put(ID, model.getApiData())
      return res
    } catch (error) {
      return Promise.reject(error)
    }
  }

  async remove(ID) {
    try {
      let res = await api.remove(ID)
      return res
    } catch (error) {
      return Promise.reject(error)
    }
  }

  async markAsProcessed(ids) {
    try {
      let res = await api.markAsProcessed({ids: ids})
      return res
    } catch (error) {
      return Promise.reject(error)
    }
  }

  async getCandidateNumber(ID) {
    try {
      let res = await api.getCandidateNumber({id: ID})
      return res
    } catch (error) {
      return Promise.reject(error)
    }
  }

  async accept(ids, props) {
    try {
      let res = await api.accept({
        cbr_user: props.сbrUser, product_name: props.productName,
        ids: ids
      })
      return res
    } catch (error) {
      return Promise.reject(error)
    }
  }

  async testAccept(ids) {
    try {
      let res = await api.testAccept({ids: ids})
      return res
    } catch (error) {
      return Promise.reject(error)
    }
  }

  async checkReservationQueueBulk(ids) {
    try {
      let res = await api.checkReservationQueueBulk({ids})
      return res
    } catch (error) {
      return Promise.reject(error)
    }
  }

  async updateReservations(ID, data) {
    try {
      let res = await api.patch(ID, {exam_reservation_requests: data})
      return res
    } catch (error) {
      return Promise.reject(error)
    }
  }

  async saveNote(ID, data) {
    try {
      let res = await api.patch(ID, {notes: data})
      return res
    } catch (error) {
      return Promise.reject(error)
    }
  }

  async saveColor(ids, colorID) {
    try {
      let res = await api.changeColor(ids, colorID)
      return res
    } catch (error) {
      return Promise.reject(error)
    }
  }


  async addCustomLog(ID, data) {
    try {
      let res = await api.addCustomLog(ID, {comment: data})
      return res
    } catch (error) {
      return Promise.reject(error)
    }
  }

  async saveIsWaitListStatus(ID, data) {
    try {
      let res = await api.patch(ID, {is_wait_list: data})
      return res
    } catch (error) {
      return Promise.reject(error)
    }
  }

  async sendExchange({ids, exchangeRequests, content, subject}) {
    try {
      let res = await api.sendExchange({ids: ids, exams: exchangeRequests, content: content, subject: subject})
      return {
        error: res.error,
        failedCandidates: res.failed_candidates.map(item => new HandleFailedModel(item))
      }
    } catch (error) {
      return Promise.reject(error)
    }
  }

  async addRequests({ids, exchangeRequests}) {
    try {
      let res = await api.addRequests({ids: ids, exam_requests: exchangeRequests})
      return {
        error: res.error,
        failedCandidates: res.failed_candidates.map(item => new HandleFailedModel(item))
      }
    } catch (error) {
      return Promise.reject(error)
    }
  }

  async removeRequests({ids, exchangeRequests}) {
    try {
      let res = await api.removeRequests({ids: ids, exams: exchangeRequests})
      return res
    } catch (error) {
      return Promise.reject(error)
    }
  }

  async getLabels() {
    try {
      let res = await apiLabels.list()
      return res
    } catch (error) {
      return Promise.reject(error)
    }
  }

  async setMijnExam(ID, data) {
    let datetime = `${data.examDate} ${data.examTime}`
    try {
      let res = await api.setMijnExam(ID, {
        [SET_MIJN_ARGS.LOCATION]: data.location,
        [SET_MIJN_ARGS.PRODUCT_NAME]: data.productName,
        [SET_MIJN_ARGS.DATETIME]: datetime,
        [SET_MIJN_ARGS.COURSE]: data.course.ID,
        reservation_code: data.reservationCode
      })
      return res
    } catch (error) {
      return Promise.reject(error)
    }
  }

  async removeMijnExam(ID) {
    try {
      let res = await api.removeMijnExam(ID)
      return res
    } catch (error) {
      return Promise.reject(error)
    }
  }

  async parseReservationNumber(ID) {
    try  {
      return await api.parseReservationNumber(ID);
    } catch (error) {
      return Promise.reject(error)
    }
  }

  async changeCourseBulk(IDs, data) {
    try  {
      return await api.changeCourseBulk({
        ids: IDs,
        course_id: data.course.ID
      });
    } catch (error) {
      return Promise.reject(error)
    }
  }

  async suggestMijn(IDs, data) {
    try {
      let res = await api.bulkSuggestMIJN( {
        ids: IDs,
        exam: {
          course_id: data.course.ID,
          location: data.location,
          exam_date: dateFormating(data.examDate).join('-'),
          exam_time_from: data.timeFrom,
          exam_time_to: data.timeTo,
        },
        subject: data.subject,
        content: data.content
        
      })
      return {
        error: res.error,
        failedCandidates: res.failed_candidates.map(item => new HandleFailedModel(item))
      }
    } catch (error) {
      return Promise.reject(error)
    }
  }

  async assignLabels(candidates, labels) {
    try {
      let res = await api.assignLabels({
        candidates: candidates,
        labels: labels
      })
      return res
    } catch (error) {
      return Promise.reject(error)
    }
  }

  async unAssignLabels(candidates, labels) {
    try {
      let res = await api.unAssignLabels({
        candidates: candidates,
        labels: labels
      })
      return res
    } catch (error) {
      return Promise.reject(error)
    }
  }

  async updateLabels(ID, data) {
    try {
      let res = await api.patch(ID, {labels: data})
      return res
    } catch (error) {
      return Promise.reject(error)
    }
  }

  async updateWillCome(ID, data) {
    try {
      let res = await api.patch(ID, {will_come_to_course: data})
      return res
    } catch (error) {
      return Promise.reject(error)
    }
  }

  async removeFromAccept(ids) {
    try {
      let res = await api.removeFromAccept({ ids })
      return res
    } catch (error) {
      return Promise.reject(error)
    }
  }

  async sync(ids) {
    try {
      let res = await api.sync({ ids })
      return res
    } catch (error) {
      return Promise.reject(error)
    }
  }

  async sendToLanding(ID) {
    try {
      let res = await api.sendToLanding(ID)
      return res
    } catch (error) {
      return Promise.reject(error)
    }
  }

  async sendEmail(ID, payload) {
    try {
      let data = {
        [EMAIL_TEMPLATE_ARGS.LABEL]: payload.label,
        [EMAIL_TEMPLATE_ARGS.SUBJECT]: payload.subject || '',
        [EMAIL_TEMPLATE_ARGS.CONTENT]: payload.content || ''
      }
      let res = await api.sendEmail(ID, data)
      return res
    } catch (error) {
      return Promise.reject(error)
    }
  } 

  async sendEmailBulk(IDs, payload) {
    try {
      let data = {
        ids: IDs,
        [EMAIL_TEMPLATE_ARGS.LABEL]: payload.label,
        [EMAIL_TEMPLATE_ARGS.SUBJECT]: payload.subject || '',
        [EMAIL_TEMPLATE_ARGS.CONTENT]: payload.content || ''
      }
      let res = await api.sendEmailBulk(data)
      return {
        error: res.error,
        failedCandidates: res.failed_candidates.map(item => new HandleFailedModel(item))
      }
    } catch (error) {
      return Promise.reject(error)
    }
  }


  async changeOnHold(ids, status) {
    try {
      let res = await api.changeOnHold( {
        ids: ids,
        is_on_hold: status
      })
      return res
    } catch (error) {
      return Promise.reject(error)
    }
  }

  async updateCourseConfiguration(ID, data) {
    try {
      let res = await api.patch(ID, {course_configuration: data})
      return res
    } catch (error) {
      return Promise.reject(error)
    }
  }

  async courseConfigurationBulk(IDs, data) {
    try  {
      return await api.courseConfigurationBulk({
        ids: IDs,
        course_configuration: data
      });
    } catch (error) {
      return Promise.reject(error)
    }
  }

}
